// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__4amIY","size_1":"styles_size_1__iA2lZ","size_2":"styles_size_2__e2BCe","paragraph":"styles_paragraph__k9eGJ"};